// -----------------缅怀先烈·通知公告
// 列表页内容
export const listdata = process.env.NODE_ENV === "production" ? 31 : 31; // 31

export const urlpostfix =
  // process.env.NODE_ENV === 'production' ? 'web-api/' : 'http://localhost:8022'
  process.env.NODE_ENV === "production"
    ? "http://yinglie.chinamartyrs.gov.cn"
    : "http://192.168.0.179:8022/";
// export const jsonpostfix = process.env.NODE_ENV === 'production' ? 'JSON/' : ''
export const jsonpostfix =
  process.env.NODE_ENV === "production" ? "/JSON/allWzJSON/" : "/allWzJSON/";

// // 烈士英明录
// export const LIESHIYML = process.env.NODE_ENV === 'production' ? 170 : 170 // 31



// WEBPACK FOOTER //
// ./src/http/global.js